import { convertOldDraft, patchDraft } from '../utils/draft.js';
import postsMixins from '@/components/dash/posts/mixins/main.js'

export default {
    vmixins: [postsMixins],
    methods: {
        prev() {
            console.log('clem43 prev',JSON.parse(JSON.stringify(this.eventsHistory)))
            this.eventsHistory.next = this.events
            if (this.eventsHistory.prev) {
                this.events = this.eventsHistory.prev
                this.eventsHistory.prev = null
                this.refreshEvents()
            }

            let calendarApi = this.$refs.calendar.getApi()
            calendarApi.prev()
            this.currentDate = calendarApi.getDate()
            this.getPlannerData(1000, true)

       
        },

        next() {
            console.log('clem43 next',JSON.parse(JSON.stringify(this.eventsHistory)))
            this.eventsHistory.prev = this.events
            if (this.eventsHistory.next) {
                this.events = this.eventsHistory.next
                this.eventsHistory.next = null
                this.refreshEvents()
            }

            let calendarApi = this.$refs.calendar.getApi()
            calendarApi.next()
            this.currentDate = calendarApi.getDate()
            console.log('clem43 next currentDate', this.currentDate)
            this.getPlannerData(1000, true)
    
        },

        setDateFromDatePiker(e) {
            console.log("setDateFromDatePiker", e.target.value)
            this.eventsHistory.prev = null
            this.eventsHistory.next = null

            let date = new Date(e.target.value)
            this.currentDate = date
            this.eventsHistory.next = this.events


            let calendarApi = this.$refs.calendar.getApi()
            calendarApi.gotoDate(e.target.value); 
            this.getPlannerData(1000, true)
        },

        goToToday() {
            this.eventsHistory.prev = null
            this.eventsHistory.next = null

            let calendarApi = this.$refs.calendar.getApi()
            calendarApi.today()
            this.currentDate = calendarApi.getDate()
            this.getPlannerData(0, true)
            
        },

        switchToMonth() {
            let calendarApi = this.$refs.calendar.getApi()
     

            const events = this.getEvents()
            
            
            if (events.length) {
                calendarApi.setOption('events', events);
            }else{ 
                calendarApi.removeAllEvents();
                // calendarApi.setOption('scrollTime', `09:00:00`);
            }
            this.currentViewType = 'dayGridMonth'
            localStorage.setItem('planner/currentViewType', 'dayGridMonth')
            calendarApi.changeView('dayGridMonth')
            // this.$nextTick(()=>{
            //     calendarApi.render()
            // })
            this.currentDate = calendarApi.getDate()
    
          
        },

        switchToWeek() {
       
            let calendarApi = this.$refs.calendar.getApi()

           
            const events = this.getEvents()

        
            if (events.length) {
                calendarApi.setOption('events', events);
            }else{ 
                calendarApi.removeAllEvents();
            }
        
            this.currentViewType = 'timeGridWeek'
            localStorage.setItem('planner/currentViewType', 'timeGridWeek')
            calendarApi.changeView('timeGridWeek')
            this.currentDate = calendarApi.getDate()
                
            
        },

        switchCurrentViewType() {
            this.eventsHistory.next = null
            this.eventsHistory.prev = null
            if (this.currentViewType === 'dayGridMonth') {
                this.switchToWeek()
            } else {
                this.switchToMonth()
            }
            this.getPlannerData(0, true)
        },

        handleDragStart({eventId}) {
            this.eventIsDrag = true
            this.lastEventDraged = this.events[eventId]
        },
        
        handleDragStop({event}) {
            
            console.log('handleDragStop', event)
    
            this.eventIsDrag = false
      
            this.$nextTick(()=>{
                const originEvent = this.lastEventDraged
                const updatedEvent = event;
                const eventId = updatedEvent.id
           

                if (originEvent) {
                    const newDate = new Date(updatedEvent.date)
                    const lastDate =  new Date(originEvent.date)
                 
                    if (Date.now() < newDate.getTime()) {
                        if (newDate.getTime() !== lastDate.getTime()) {

                            if (this.events[eventId]) this.events[eventId].date = newDate.toISOString()
                        
                            // if (calendarApi.view.type == "timeGridWeek" && (!this.moreContentGridWeek.isOpen || info.event.start.getTime() !== updatedEvent.start.getTime())) {
                            //     this.refreshEvents()
                                
                            // }
                            this.changeDatePost(eventId, newDate)
                        }
                    }else{
                        this.refreshEvents()
                    }
                   
                }
            })
        },

        handleDateSelect(dateSelected) {
            console.log('handleDateSelect', dateSelected)
            let calendarApi = this.$refs.calendar.getApi()


            let currentDate = new Date()

            if (this.$refs.calendar.view == "dayGridMonth") {
                currentDate.setHours(0)
                currentDate.setMinutes(0)
                currentDate.setMilliseconds(0)
            }
            
            let scheduleDate = new Date(dateSelected)

            if (scheduleDate < currentDate) {
                return
            }

            if (this.$refs.calendar.view == "dayGridMonth") {
                if (currentDate.toLocaleDateString('sv') == dateSelected) {
                    scheduleDate = new Date(Date.now() + 1000 * 60 * 10)  // +10 minutes
                }else {
                    scheduleDate.setHours(9)
                }
            }

            this.$router.push({
                name: 'postCreator',
                query: { scheduleDate: scheduleDate.toISOString()}
            })
          
        },

        async handleEventClick(eventId, fetchPost=true) {
   
            //convert old draft
            console.log('handleEventClick', this.events[eventId], eventId , this.events[eventId].id)
            if (!this.events[eventId]) return
            const event = this.events[eventId]
            console.log("handleEventClick event", this.events[eventId], eventId, Object.keys(this.events))
            
            if (this.events[eventId].originalStatus == 'draft' && (!this.events[eventId].draft || !this.events[eventId].draft.saveAllFormData)) {
                //post V1
                this.$router.push({ 
                    name: 'planner',
                    query: {
                        no_redirection: true,
                        post_id:  this.events[eventId].originalPost.id,
                        page_id:  this.events[eventId].page.id,
                        bot_id: this.events[eventId].originalPost._bots[0].id,
                        is_draft: this.events[eventId].originalStatus == 'draft',
                        show_post:1
                    }
                });
                return 
            }
            console.log('handleEventClick before convertOldDraft')

            if (this.events[eventId].draft && this.events[eventId].draft.saveAllFormData) {
                patchDraft(this.events[eventId].draft)

                if (eventId.endsWith('_storification')) {
                    this.$set(this.events[eventId].draft, 'tab', "story_share")
                }else if (this.events[eventId].draft.tab == "story_share") {
                    this.$set(this.events[eventId].draft, 'tab', "standard")
                }
            }

            this.eventIdSelected = eventId
            console.log('handleEventClick after buildEvent', this.events[eventId])

            if (fetchPost) {
                let body;
                if (this.events[event.id].originalStatus == 'draft') {
                    const reponse = await this.findDraft(this.events[event.id].originalPost._bots[0].id, this.events[event.id].originalPost._id)
                    body = reponse.body
                }else{
                    const reponse = await this.findPost(this.events[event.id].originalPost._bots[0].id, this.events[event.id].originalPost.id, this.events[event.id].originalPost.page[0].post_number)
                    body = reponse.body
                }
                console.log('test1', body)
                if (body.post && body.post.page && body.post.page.length >= 2) {
                    console.log('test', event.id.endsWith('_storification'),JSON.parse(JSON.stringify(body.post.page)))
                    if (event.id.endsWith('_storification')) {
                        body.post.page = [body.post.page.find(p => p.storification && p.story)]
                    }else{
                        body.post.page = [body.post.page.find(p => !p.storification || !p.story)]
                    }
                    console.log('test 2',JSON.parse(JSON.stringify(body.post.page)))
                }

                const newEvent = await this.buildEvent({
                    ...this.events[event.id].originalPost,
                    ...body.post,
                }, true);
                newEvent.id = event.id
                this.events[event.id] = newEvent

                this.handleEventClick(event.id, false) //pour convertir le draft
            }
        },

        handleEvents(events) {
            /*
                déclanché pratiquement a chaque fois qu'une action est faire
            */
            console.log('handleEvents', events)
            this.currentEvents = events
        },

        refreshEvents() {
            console.log('refreshEvents')
            let calendarApi = this.$refs.calendar.getApi()

            const events = this.getEvents()
            console.log('refreshEvents events',events)
            if (events.length) {
                calendarApi.addEvents(events);
            }else{ 
                calendarApi.removeAllEvents();
            }
            
        },

        getEvents(events = this.events) {
          
           
            let eventBuild, isSearchBarMatching;
            const eventsBuild =  Object.values(events).reduce((acc, event) => {
                isSearchBarMatching = !this.filter.search || (event.content && event.content.toLowerCase().includes(this.filter.search))
                console.log("getEventsForMonth",event.status, event.id)
                if (this.filter.statusDisplay[event.status] && isSearchBarMatching && (!event.type || this.filter.typesDisplay[event.type])) {
           
                    eventBuild = {
                        ...event
                    }
               
                    if (!['scheduled','draft'].includes(event.originalStatus)) {
                        eventBuild.editable= false // Empêche toute modification
                    }
                    acc.push(eventBuild)
                }

                return acc
            },[]) 
            console.log("getEventsForMonth", eventsBuild)
            return eventsBuild
        }
    },
  };